import React from 'react'
import PropTypes from 'prop-types';
import Select, {components} from 'react-select'
import Price from './Price';
import buttons from './Button.scss';
import styles from './SelectPrice.scss';

const customStyles = {
	container: (base) => ({
		...base,
		display: 'inline-block',
		width: '100%',
		minWidth: '230px',
		maxWidth: '320px',

	}),
	indicatorSeparator: () => ({
		display: 'none'
	}),
	dropdownIndicator: () => ({
		display: 'none'
	}),
	control: () => ({
		border: 'none',
		cursor: 'default',
		transition: 'all 100ms',
		position: 'relative',
		display: 'inline-block',
		fontFamily: 'Georgia, Geneva, "Times New Roman", Times, serif',
		fontSize: '16px',
		lineHeight: '24px',
		height: '24px',
		width: '100%',
		minWidth: '230px',
		maxWidth: '320px',
	}),
	dummyInput: (base) => ({
		...base,
		display: 'none'
	}),
	valueContainer: (base) => ({
		...base,
		padding: 0,
		overflow: 'visible',
		height: '19px',
	}),
	singleValue: (base) => ({
		...base,
		width: '100%'
	}),
	menu: () => ({
		top: '-2px',
		left: '50%',
		transform: 'translate(-50%)',
		position: 'absolute',
		backgroundColor: 'white',
		width: '100%',
		minWidth: '230px',
		maxWidth: '320px',
		borderRadius: '6px',
		boxShadow: '1px 1px 6px -1px #999',
		fontFamily: 'Georgia, Geneva, "Times New Roman", Times, serif',
		fontSize: '16px',
		lineHeight: '36px',
		zIndex: '2'
	}),
	option: (base, {isFocused, isSelected}) => ({
		...base,
		backgroundColor: isFocused || isSelected ? "#f5f5f5" : 'white',
		color: '#333333',
		padding: 0,
		'&:hover': {
			backgroundColor: "#f5f5f5"
		},
		'& table': {
			width: '100%',
			'& td': {
				whiteSpace: 'nowrap',
				textAlign: 'right'
			},
			'& td:first-of-type': {
				textAlign: 'left',
				paddingLeft: '15px'
			},
			'& td:last-of-type': {
				width: '23px',
				paddingRight: '15px'
			},
		}
	})
};

const SelectPrice = (
	{
		valueCol,
		labelCol,
		oldPriceCol,
		newPriceCol,
		currencyCol,
		showStarToId,
		options,
		selected,
		onChange,
		placeholder,
		onMenuOpen,
		name,
		id,
	}
) => {
	SelectPrice.propTypes = {
		valueCol: PropTypes.string.isRequired,
		labelCol: PropTypes.string.isRequired,
		oldPriceCol: PropTypes.string.isRequired,
		newPriceCol: PropTypes.string.isRequired,
		currencyCol: PropTypes.string.isRequired,
		options: PropTypes.arrayOf(PropTypes.object).isRequired,
		name: PropTypes.string,
		id: PropTypes.string,
		selected: PropTypes.string,
		showStarToId: PropTypes.string,
		onChange: PropTypes.func,
		onMenuOpen: PropTypes.func,
		placeholder: PropTypes.string
	};

	const Option = (props) => {
		return (
			<div data-test={`${name}-value-${props.data[valueCol]}`}>
				<components.Option {...props} >
					<table>
						<tbody>
						<tr>
							<td>{props.data[labelCol]}</td>
							<td className={styles.oldPrice}>
								{
									props.data[oldPriceCol] !== props.data[newPriceCol] ? props.data[oldPriceCol] : null
								}
							</td>
							<td>
								<Price
									currency={props.data[currencyCol]}
									value={props.data[newPriceCol]}
									currencyClass={styles.currency}/>
							</td>
							<td>
								{
									props.data[valueCol] === showStarToId ? '*' : null
								}
							</td>
						</tr>
						</tbody>
					</table>
				</components.Option>
			</div>
		);
	};

	return (
		<Select
			id={id}
			name={name}
			className={'tstselect'}
			options={options}
			styles={customStyles}
			isSearchable={false}
			placeholder={
				<table className={styles.selectedValueContainer}>
					<tbody>
					<tr>
						<td className={styles.anchorContainer}>
							<a href="#" className={buttons.action}>
								{
									typeof placeholder !== 'undefined' && placeholder !== '' ? placeholder : 'Select...'
								}
							</a>
							<span className={styles.icon}/>
						</td>
					</tr>
					</tbody>
				</table>
			}
			components={{Option}}
			getOptionLabel={option => {
				return (
					<table className={styles.selectedValueContainer}>
						<tbody>
						<tr>
							<td className={styles.anchorContainer}>
								<a
									href="#"
									className={buttons.action}
									data-text={option[labelCol]}>
									{option[labelCol]}
								</a>
								<span className={styles.icon}/>
							</td>
							<td className={styles.oldPrice}>
								{
									option[oldPriceCol] !== option[newPriceCol] ? option[oldPriceCol] : null
								}
							</td>
							<td>
								<Price
									currency={option[currencyCol]}
									value={option[newPriceCol]}
									currencyClass={styles.currency}/>
							</td>
							<td>
								{
									option[valueCol] === showStarToId ? '*' : null
								}
							</td>
						</tr>
						</tbody>
					</table>
				)
			}}
			getOptionValue={option => `${option[valueCol]}`}
			onChange={onChange}
			onMenuOpen={onMenuOpen}
			value={
				(typeof selected !== 'undefined' && selected !== '' && selected) ?
					options.filter((option) => {
						if (selected.indexOf(option[valueCol]) !== -1) {
							return true;
						}
					})
					: false
			}/>
	)
};

export default SelectPrice;


